import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tabs from '@mui/material/Tabs';
import Toolbar from '@mui/material/Toolbar';
import { Skeleton } from '@mui/material';
import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import SwipeableViews from 'react-swipeable-views';
import { bindActionCreators } from 'redux';
import { openRequestModal } from '../../actions/modals';
import { clearOlympData, getOlympResults, processOlympType } from '../../actions/olympiad';
import './index.css';

import { Checkbox, FormControlLabel } from '@mui/material';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import CountUp from 'react-countup';
import OlympiadService from '../../services/olympiad.service';
import { apiService } from '../../services/requestV2.service';

const periods = [
    { key: 'day', label: 'dashboard.per_day', value: 'day' },
    { key: 'week', label: 'dashboard.per_week', value: 'week' },
    { key: 'month', label: 'dashboard.per_month', value: 'month' },
    { key: 'quarter', label: 'dashboard.per_quarter', value: 'quarter' },
    { key: 'year', label: 'За рік', value: 'year' },
];

class OlympiadPage extends React.Component {
    state = {
        index: 0,
        periodMode: false,
        studentsCount: null,
    };

    handleCheckboxChange = event => {
        const value = event.target.checked;
        this.setState({ periodMode: value });
        localStorage.setItem('periodMode', JSON.stringify(value));
    };

    processStudentsCount = async () => {
        try {
            const count = await OlympiadService.OlympiadCount();
            if (!count) return;
            this.setState({ studentsCount: count });
        } catch (error) {
            console.error(error);
        }
    };

    handleOlympiadParticipants = key => {
        this.props.history.push(`/olympiad/${key}`);
    };

    handleSwipeChange = index => {
        this.setState({ index });
    };
    componentDidMount() {
        apiService.setCurrentPage('/olympiad');
        const savedMode = localStorage.getItem('periodMode');
        if (savedMode !== null) {
            this.setState({ periodMode: JSON.parse(savedMode) });
        }
        this.props.getOlympResults();
        this.processStudentsCount();
    }
    componentWillUnmount() {
        this.props.clearOlympData();
        apiService.cancelAllRequests('/olympiad');
    }

    processDate(item, type) {
        let d = new Date(item);

        const _min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
        const _hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
        const _month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
        const _date = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();

        const date = `${_date}.${_month}.${d.getFullYear()}`;
        const dateTime = `${_date}.${_month}.${d.getFullYear()} ${_hours}:${_min}`;
        return type === 'champs' ? date : dateTime;
    }

    processTable(type = false) {
        const { olympiad, t } = this.props;
        const reducer = type === 'champs' ? olympiad.champions : olympiad.list;
        let data = {};
        for (let item in reducer) {
            if (reducer[item].length) {
                data[`olympiad.${item}`] = reducer[item];
            }
        }
        return (
            <>
                {data &&
                    Object.keys(data).map((el, index) => {
                        return (
                            <Paper className="olympiad_table" key={index}>
                                <Toolbar>
                                    <Typography variant="h6" id="tableTitle" component="div">
                                        {t(el)}
                                    </Typography>
                                </Toolbar>
                                <TableContainer component={Paper}>
                                    <Table aria-label="a dense table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>№</TableCell>
                                                <TableCell align="left">{t('olympiad.student')}</TableCell>
                                                <TableCell align="left">{t('olympiad.right_stat')}</TableCell>
                                                <TableCell align="left">{t('olympiad.speed')}</TableCell>
                                                <TableCell align="left">{t('olympiad.group')}</TableCell>
                                                <TableCell align="left">{t('olympiad.date')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data[el].map((row, i) => {
                                                return (
                                                    <TableRow key={`${type}.${row.answer_avg_time}`}>
                                                        <TableCell>
                                                            {type === 'champs' ? i + 1 : row.position}
                                                        </TableCell>
                                                        <TableCell align="left">{row.user}</TableCell>
                                                        <TableCell align="left">{row.answer_correct}</TableCell>
                                                        <TableCell align="left">{row.answer_avg_time}</TableCell>
                                                        <TableCell align="left">{row.group.split('|||')[0]}</TableCell>
                                                        <TableCell align="left">
                                                            {this.processDate(
                                                                type === 'champs' ? row.olimp_date : row.created,
                                                                type
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        );
                    })}
            </>
        );
    }

    render() {
        const { t } = this.props;
        const loading = this.props.olympiad && this.props.olympiad.list && Object.keys(this.props.olympiad.list).length;
        const handleChange = (event, value) => {
            this.setState({
                index: value,
            });
        };
        const { index } = this.state;
        const role_id = this.props.user.emulation.length
            ? this.props.user.emulation[this.props.user.emulation.length - 1].info.role_id
            : this.props.user.info.role_id;
        return (
            <Fragment>
                <h2 className="container-header"> {t('sidebar.olympiad')} </h2>
                {role_id === 4 && (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={this.state.periodMode}
                                onChange={this.handleCheckboxChange}
                                color="success"
                            />
                        }
                        label="ОЛІМПІАДА ЗА ПЕРІОД"
                    />
                )}

                {this.state.periodMode || role_id === 3 ? (
                    <Paper elevation={0}>
                        <Box m={2} p={2}>
                            <Typography component="div">{t('olympiad.title')}:</Typography>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
                                    gridTemplateRows: 'auto',
                                    maxWidth: '200px',
                                    gap: 2,
                                }}
                            >
                                {periods.map(({ key, label, value }) =>
                                    this.state.studentsCount ? (
                                        <ListItem
                                            key={key}
                                            button
                                            divider
                                            style={{ width: 250 }}
                                            onClick={() => this.handleOlympiadParticipants(key)}
                                        >
                                            <ListItemText primary={t(label)} />
                                            <Box className="counter">
                                                {!+this.state.studentsCount[value] ? (
                                                    0
                                                ) : (
                                                    <CountUp duration={2.75} end={this.state.studentsCount[value]} />
                                                )}
                                            </Box>
                                        </ListItem>
                                    ) : (
                                        <ListItem key={key} style={{ width: 250 }}>
                                            <Skeleton width={'100%'} height={'40px'} variant="text" />
                                        </ListItem>
                                    )
                                )}
                            </Box>
                        </Box>
                    </Paper>
                ) : (
                    <>
                        <Tabs value={index} onChange={handleChange} className="olymp_swipe">
                            <Tab label={t('sidebar.olympiad')} />
                            <Tab label={t('olympiad.champions')} />
                        </Tabs>
                        <SwipeableViews index={index} onChangeIndex={this.handleSwipeChange}>
                            <div>
                                {!loading ? (
                                    <>
                                        <Skeleton
                                            className="olympiad_loading"
                                            variant="rect"
                                            width={'100%'}
                                            height={150}
                                        />
                                        <Skeleton
                                            className="olympiad_loading"
                                            variant="rect"
                                            width={'100%'}
                                            height={150}
                                        />
                                        <Skeleton
                                            className="olympiad_loading"
                                            variant="rect"
                                            width={'100%'}
                                            height={150}
                                        />
                                    </>
                                ) : (
                                    this.processTable()
                                )}
                            </div>
                            <div>
                                {!loading ? (
                                    <>
                                        <Skeleton
                                            className="olympiad_loading"
                                            variant="rect"
                                            width={'100%'}
                                            height={150}
                                        />
                                        <Skeleton
                                            className="olympiad_loading"
                                            variant="rect"
                                            width={'100%'}
                                            height={150}
                                        />
                                        <Skeleton
                                            className="olympiad_loading"
                                            variant="rect"
                                            width={'100%'}
                                            height={150}
                                        />
                                    </>
                                ) : (
                                    this.processTable('champs')
                                )}
                            </div>
                        </SwipeableViews>
                    </>
                )}
            </Fragment>
        );
    }
}

const widthConnect = connect(
    state => ({ olympiad: state.olympiad, user: state.user }),
    dispatch =>
        bindActionCreators(
            {
                getOlympResults,
                openRequestModal,
                clearOlympData,
                processOlympType,
            },
            dispatch
        )
);

export default withTranslation()(widthConnect(OlympiadPage));
